import styled from '@emotion/styled';
import { Text, H3 } from 'ds/components/typography';
import { Link } from 'components/link';
import { colorToAlpha } from 'helpers/insight';


export const ProjectPromotedSectionWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding-bottom: ${theme.spacing(3)};
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    padding-bottom: ${theme.spacing(3)};
  `}
`;

export const ProjectSectionHeader = styled(H3)`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-bottom: ${theme.spacing(2)};
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    margin-bottom: ${theme.spacing(3)};
  `}
`;

export const ProjectCount = styled(Text.withComponent('span'))`
  color: ${({ theme }) => theme.colors.neutrals.grey4};
`;

export const ProjectSectionInner = styled(Text)<{ isPromoted?: boolean; isScrollable?: boolean; }>`
  display: flex;
  flex-wrap: wrap;

  ${({ theme, isScrollable }) => isScrollable ? `
    margin: 0 -${theme.spacing(3)};

    .scrollBox {
      margin: 0 ${theme.spacing(2.5)} 0 ${theme.spacing(3)};
    }
  ` : `
    margin: 0 -${theme.spacing(0.5)};
  `}
`;

export const ShowMoreProjects = styled(H3)`
  ${({ theme }) => `
    margin-top: ${theme.spacing(1)};
    color: ${theme.colors.neutrals.grey2};
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: ${theme.colors.brand.main};
      text-decoration: none;
    }
  `}
`;

export const EmptyStateWrapper = styled.div`
  ${({ theme }) => `
    text-align: center;
    padding: ${theme.spacing(16)} 0 ${theme.spacing(5)};
  `}
`;

export const EmptyStateDescription = styled(Text)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
    margin-top: ${theme.spacing(2)};
    white-space: pre-wrap;
  `}
`;

export const EmptyStateLink = styled(Link)`
  ${({ theme }) => `
    color: ${theme.colors.brand.main};
  `}
`;

export const ProjectsWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    overflow: hidden;
    border-bottom: 1px solid ${theme.colors.neutrals.grey8};
    &:not(:last-of-type) {
      border-bottom: 1px solid ${colorToAlpha(theme.colors.neutrals.black, 0.12)};
    }
  `}
`;

export const Line = styled.div`
  height: 1px;
  ${({ theme }) => `
    background: ${theme.colors.neutrals.grey8};
    margin: ${theme.spacing(3)} 0 ${theme.spacing(5)};
  `}
`;
